import styled from "styled-components";

export const ForgottenPasswordBox = styled.div`
  padding: 1rem;
  margin-bottom: 1.5rem;

  background-color: var(--white);
  border-radius: 4px;
`;
